import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Services.module.scss";
import { Context } from "../../Store";
import vector0 from "../../../imgs/vector0.svg";
import frame from "../../../imgs/mobileImg0.png";
import background2 from "../../../imgs/vector1.png";
import Slider from "./Slider";
import Loading from "../../Loading/Loading";
const Services = (props) => {
  const {
    dir,
    setIsClicked,
    servicesSection,
    clickBtn,
    clickbtns,
    servicesRes,
    servicesResdata,
    servicesResLoading,
  } = useContext(Context);
  const { googlePlay } = props;
  // const servicesResFilter = servicesRes.filter(
  //   (service) => service.status === 1
  // );
  let { title, subTitle } = servicesResdata;
  useEffect(() => {
    setIsClicked(false);
  }, [setIsClicked]);
  return (
    <>
      <section ref={servicesSection} id={styles.services}>
        {servicesResLoading ? (
          <Loading />
        ) : (
          <>
            <div className={styles.intro}>
              <img
                className={
                  dir === "ltr"
                    ? `${styles.vectorimgLtr}`
                    : `${styles.vectorimgRtl}`
                }
                src={vector0}
                alt=""
              />

              <div className={styles.container0}>
                <h2>{title}</h2>
                <p>{subTitle}</p>
                <a href={googlePlay} target="_blank">
                  <button
                    onClick={() => clickBtn("contactUs", 5)}
                    className={clickbtns === "contactUs" ? "clickBtns" : ""}
                  >
                    {dir === "ltr" ? "Start Now" : "ابدأ الان"}
                  </button>
                </a>
              </div>
              <div className={styles.mobileImg}>
                <img
                  className={
                    dir === "ltr" ? `${styles.frameLtr}` : `${styles.frameRtl}`
                  }
                  src={frame}
                  alt=""
                />
              </div>
            </div>
            <div className={styles.items}>
              <img
                className={
                  dir === "ltr"
                    ? `${styles.backgroundLtr}`
                    : `${styles.backgroundRtl}`
                }
                src={background2}
                alt=""
              />
              <div className={styles.container}>
                {servicesRes.map((service) => (
                  <div className={styles.item} key={service.id}>
                    <img src={service.logo} alt="" />
                    <h2>{dir === "ltr" ? service.name : service.name}</h2>
                    <p>{dir === "ltr" ? service.desc : service.desc}</p>
                  </div>
                ))}
              </div>
              <div className={styles.container1}>
                <Slider />
              </div>
            </div>
          </>
        )}
      </section>
    </>
  );
};

export default Services;
